import { useEffect } from "react";
import "../../assets/css/product.scss";
import ProductStep1Component from "../../components/product/step1_component";
import { SessionStorageUtil } from "../../utils/session_storage_util";
import { useNavigate } from "react-router-dom";

function ProductStep1Page() {
  const navigate = useNavigate();

  useEffect(() => {
    if (SessionStorageUtil.getItem("accessToken")) {
      navigate("/product_step2", { replace: true });
    }
  }, [navigate]);

  if (SessionStorageUtil.getItem("accessToken")) {
    return null;
  }

  return <ProductStep1Component pathPrefix="product" />;
}

export default ProductStep1Page;
